import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "hue-container",
      ref: "hueRef",
      onMousedown: _cache[0] || (_cache[0] = $event => _ctx.handleMouseDown($event))
    }, [
      _createElementVNode("div", {
        class: "hue-pointer",
        style: _normalizeStyle({ left: _ctx.pointerLeft })
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "hue-picker" }, null, -1)
      ]), 4)
    ], 544)
  ]))
}